import _each from "lodash/each";
import { gsap } from "gsap";
import store from "~/js/store/store";
export default class SideNavi {
  constructor() {
    this.view = document.querySelector("#navi-wrap");
    this.setup();
  }

  setup() {
    const naviList = document.querySelectorAll(".js-sectionnavi");
    this.unsubscribe = store.subscribe((mutation, state) => {
      if (mutation.type === "pinSectionAutoplayTime") {
        this.updateCircleIndicator(state.app.pinSection.autoPlayTime);
      }
    });
    _each(naviList, (elm, index) => {
      elm.addEventListener("click", (event) => {
        event.preventDefault();
        let target = event.currentTarget;
        let _active = target.getAttribute("data-active");
        store.dispatch("changePinScroll", {
          index: parseInt(_active, 10)
        });
        // this.goToSection(parseInt(_active, 10))
      });
    });
  }

  // サイドナビ更新
  updateNavi() {
    let currentIndex = store.state.app.pinSection.nextIndex;
    const naviList = this.view.querySelectorAll(".js-sectionnavi");
    const sections = document.querySelectorAll(".js-section");
    _each(naviList, (elm, index) => {
      let circle = elm.querySelector(".js-circle");
      if (circle) {
        gsap.set(circle, {
          "stroke-dashoffset": 50
        });
      }
      elm.classList.remove("active");
      if (index === currentIndex) {
        elm.classList.add("active");
        let section = sections[index];
        this.view.classList.remove("white");
  
        if (section.classList.contains("white_pc")) {
          if (window.innerWidth >= 1025) {
            this.view.classList.add("white");
          }
        } else if (section.classList.contains("white_sp")) {
          if (window.innerWidth <= 1024) {
            this.view.classList.add("white");
          }
        } else if (section.classList.contains("white")) {
          this.view.classList.add("white");
        }
      }
    });
  }

  // 自動再生インジケーターの更新
  updateCircleIndicator(time) {
    const currentIndex = store.state.app.pinSection.nextIndex;
    const naviList = this.view.querySelectorAll(".js-sectionnavi");
    let targetCircle = naviList[currentIndex];
    if (targetCircle) {
      targetCircle = targetCircle.querySelector(".js-circle");
      if (targetCircle) {
        gsap.set(targetCircle, {
          "stroke-dashoffset": 50 - time * 25
        });
      }
    }
  }
}
